import {LoadingResult, LoadingResultProps} from "~/apps/core/ui/LoadingResult";
import makeStyles from "@mui/styles/makeStyles";


export type LoadingBoxProps = LoadingResultProps & {
    children?: any
}


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column"
    },
    loader: {
        flexGrow: 1
    }
}));


export const LoadingBox = (props: LoadingBoxProps) => {
    const {children, ...loadingProps} = props;
    const classes = useStyles(props);
    const showChildren = !loadingProps.empty && !loadingProps.error;

    return (
        <div className={classes.root}>
            {showChildren && children}
            <LoadingResult {...loadingProps} className={classes.loader} />
        </div>
    )
}